import styled, { css, keyframes } from "styled-components";

export const Container = styled.div`
  height: 72px;
  background-color: #fff;
  top: 0;
  left: 0;
  border-bottom: 1px solid #e2e8f0;
  position: fixed;
  display: flex;
  flex-wrap: wrap;
  z-index: 1;
  display: flex;
  align-self: center;
  flex: 1;
  width: 100%;
  justify-content: space-between;
`;

export const InfoText = styled.p`
  font-size: 14px;
  font-weight: normal;
`;

export const Navigation = styled.div`
  display: flex;
  align-self: center;
  flex: 1;
  justify-content: space-between;
  margin-left: 30px;
  margin-right: 30px;

  ${(props) =>
    props.sidebarIsVisible &&
    css`
      padding-left: 80px;
    `}
`;

export const NavigationText = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

export const NavigationContainer = styled.div`
  align-items: center;
  display: flex;
`;

export const Avatar = styled.img`
  width: 24px;
  border-radius: 50%;
`;

export const UserContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

export const UserText = styled.span`
  font-weight: 600;
  font-family: "Inter", sans-serif;
  line-height: 150%;
  letter-spacing: 0px;
  text-align: center;
  font-size: 16px;
  color: #62748e;
  @media (max-width: 609px) {
    font-size: 12px;
  }
  @media (max-width: 374px) {
    font-size: 10px;
  }

  ${({ logout }) =>
    logout &&
    css`
      cursor: pointer;
      font-weight: 400;
    `}
`;

export const AccountContainer = styled.div`
  min-width: 200px;
`;

export const LanguageContainer = styled.div`
  display: flex;
  align-items: center;
  svg {
    cursor: pointer;
  }
`;

export const SelectedLanguageContainer = styled.div`
  cursor: pointer;
`;

export const SelectedLanguage = styled.img`
  width: 24px;
  height: 24px;
  object-fit: fill;
  border-radius: 50%;
  // @media (max-width: 768px) {
  //   right: 60px;
  //   position: relative;
  // }
`;
export const LogoutContainer = styled.div`
  display: flex;
  align-items: center;
  svg {
    cursor: pointer;
  }
`;

const easein = keyframes`
0%{
  opacity: 0;
  border-top-color: transparent;
}
100%{
  opacity: 1;
  border-top-color: #E2E8F0;
}
`;

export const LanguageDropdownContainer = styled.div`
  background-color: #fff;
  /* height: 100px;
  width: 200px; */
  right: 40px;
  top: 71px;
  position: fixed;
  border-top: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  animation: ${easein} 200ms ease-in-out forwards;

  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.4);
  @media (max-width: 540px) {
    right: 0px;
    width: calc(100% - 80px);
    left: 80px;
    ${(props) =>
      !props.sidebarIsVisible &&
      css`
        width: 100%;
        left: 0px;
      `}
  }
`;

export const Flag = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 50%;
  margin: 0px 8px;
  @media (max-width: 768px) {
    right: 40px;
    position: relative;
  }
`;

export const FlagContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 8px;
  transition: 300ms ease-in-out;

  &:hover {
    background-color: #002244;
    color: #cccccc;
  }
`;

export const FlagText = styled.span`
  /* max-width: 200px;
  min-width: 100px; */
  width: 70px;
`;

export const Logo = styled.img`
  width: 36.83333206176758px;
  height: 34px;
  object-fit: contain;
  margin-right: 28px;
`;

export const UserIconWrapper = styled.div`
  width: 20px;
  height: 20px;
  background: #e2e2f733;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  // @media (max-width: 520px) {
  //   display: none;
  // }
`;

export const EndServiceAndIconEyeContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const EndServiceItens = styled.div`
  display: flex;
  align-items: center;
  background: transparent;
  gap: 8px;
  @media (max-width: 520px) {
    position: absolute;
    left: 10px;
    top: 80px;
  }
`;
